import React from 'react';

import { Description } from './styles';
type GroupHeaderDescriptionProps = {
    description?: string;
};
export const GroupHeaderDescription = ({ description, ...others }: GroupHeaderDescriptionProps) =>
    description?.length ? <Description {...others}>{description}</Description> : null;
